import QuotationError from './QuotationError';
class QuotationInvalidNumberOfBricks extends QuotationError {
    constructor(options) {
        super('The number of bricks is missing or not a number', options);
    }
}
export default QuotationInvalidNumberOfBricks;
